import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { apiGetPolicyDocumentInfo } from '@jove-frontend/uikit';
export var usePolicyDocument = function usePolicyDocument() {
  var _useState = useState(false),
      policyDocumentLoading = _useState[0],
      setPolicyDocumentLoading = _useState[1];

  var _useState2 = useState([]),
      policyDocumentList = _useState2[0],
      setPolicyDocumentList = _useState2[1];
  /**
   * requestes
   */


  var requestPolicyDocumentList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
      var _yield$apiGetPolicyDo, _yield$apiGetPolicyDo2, res, list;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPolicyDocumentLoading(true);
              _context.next = 3;
              return apiGetPolicyDocumentInfo({
                policy_id: config === null || config === void 0 ? void 0 : config.policyId
              });

            case 3:
              _yield$apiGetPolicyDo = _context.sent;
              _yield$apiGetPolicyDo2 = _slicedToArray(_yield$apiGetPolicyDo, 1);
              res = _yield$apiGetPolicyDo2[0];
              setPolicyDocumentLoading(false);
              list = (res === null || res === void 0 ? void 0 : res.data) || [];

              if (res) {
                setPolicyDocumentList(list);
              }

              return _context.abrupt("return", list);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestPolicyDocumentList(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    requestPolicyDocumentList: requestPolicyDocumentList,
    policyDocumentList: policyDocumentList,
    policyDocumentLoading: policyDocumentLoading
  };
};